import { createRouter, createWebHistory } from "vue-router";

const routes = [
  {
    path: "/subscribe/",
    name: "Оформление подписки",
    component: () => import("../views/Subscription.vue"),
    meta: { transition: 'slide-right' },
  },
  {
    path: "/subscribe_vip/",
    name: "Подписка",
    component: () => import("../views/SubscriptionVip.vue"),
  },
  {
    path: "/management/",
    name: "Управление подпиской",
    component: () => import("../views/Management.vue"),
    meta: { transition: 'slide-right' },
  },
  {
    path: "/services/",
    name: "Дополнительные услуги",
    component: () => import("../views/ManagementServices.vue"),
    meta: { transition: 'slide-left' },
  },
  {
    path: "/unsubscribe_reasons/",
    name: "Причины отписки",
    component: () => import("../views/UnsubscribeReasonSelect.vue"),
    meta: { transition: 'slide-left' },
  },
  {
    path: "/unsubscribe/",
    name: "Отписка",
    component: () => import("../views/Unsubscribe.vue"),
    meta: { transition: 'slide-left' },
  },
  {
    path: "/pay_methods/",
    name: "Выбор метода оплаты",
    component: () => import("../views/PayMethodChoice.vue"),
    meta: { transition: 'slide-left' },
  },
  {
    path: "/map/",
    name: "Карта камер дофомонов",
    component: () => import("../views/Map.vue"),
    meta: { transition: 'slide-left' },
  },

];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
